import React from 'react'
import HeaderComp from '../CommanCom/HeaderComp'
import FooterComp from '../CommanCom/FooterComp'

function UserRoutes({ redirectpath = 'login', children, header_title }) {
    return (
        <div className="user_main_container">
            <HeaderComp />
            <main id="dash_content_area">
                {children ? children : ''}
                <FooterComp />
            </main>
        </div>

    )
}

export default UserRoutes
